/* eslint-disable no-mixed-operators */

import React, { useState, useEffect } from 'react';
// import { useRef } from 'react';

// import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

// import RESTUtils from '../../utils/rest-utils';

// import QrReader from 'react-qr-scanner';

// import { readAndCompressImage } from 'browser-image-resizer';

import { HorizontallyCenteringContainer, VerticalSeparator, telegramQRScan, telegramHapticFeedback, hexDecode } from './utils';

import { isDev } from '../../utils/general-utils';

const INCLUDE_GEOLOCATION_TEST = false;

const DEBUG_ELEMENTS_ALLOWED_CARD_NUMBERS = ['82089151'] 


export default function DebugAndTestingElements({ token, memberData }) {
    const [showDebugElements, setShowDebugElements] = useState(false);
    // const [debugCameraUploadResult, setDebugCameraUploadResult] = useState(null);
    // const [debugQrScanResult, setDebugQrScanResult] = useState(null);
    const [debugWindowDialogResult, setDebugWindowDialogResult] = useState(null);
    const [debugPopupResult, setDebugPopupResult] = useState(null);
    const [debugRequestContactResult, setDebugRequestContactResult] = useState(null);
    const [debugTelegramQrScanResult, setDebugTelegramQrScanResult] = useState(null);
    const [debugMediaInfo, setDebugMediaInfo] = useState(null);
    const [debugLocationInfo, setDebugLocationInfo] = useState(null);

    useEffect(() => {
        if (isDev) {
            navigator.mediaDevices.enumerateDevices().then(miList => {
                console.log('mediaDevices:')
                miList.forEach(mi => {
                    console.log(' - ', mi.toJSON())
                })
                setDebugMediaInfo(miList.map(mi => mi.toJSON()))
            })
            if (INCLUDE_GEOLOCATION_TEST && !!navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(r => {
                    // console.log('Geolocated:', r)
                    setDebugLocationInfo({
                        coords: {
                            accuracy: r.coords.accuracy,
                            altitude: r.coords.altitude,
                            altitudeAccuracy: r.coords.altitudeAccuracy,
                            heading: r.coords.heading,
                            latitude: r.coords.latitude,
                            longitude: r.coords.longitude,
                            speed: r.coords.speed,
                        },
                        timestamp: r.timestamp
                    })
                }, e => console.error('Geolocation Error:', e));
            }
        }
    }, []);

    const [telegramWebAppEventText, setTelegramWebAppEventText] = useState(`Log started at: ${(new Date()).toLocaleTimeString()}`);
    const telegramWebAppVersion =  Number(window?.Telegram?.WebApp?.version) || 0

    if (window?.Telegram?.WebApp && window?.Telegram?.WebApp?.platform !== 'tdesktop' && window?.Telegram?.WebApp?.platform !== 'unknown' && telegramWebAppVersion >= 6.2) {
        [
            'themeChanged',
            // 'viewportChanged',
            'mainButtonClicked', 'backButtonClicked', 'settingsButtonClicked',
            'invoiceClosed',
            'popupClosed',
            'qrTextReceived', 'clipboardTextReceived',
            'writeAccessRequested', 'contactRequested'
        ].forEach(eventType => {
            window.Telegram.WebApp.onEvent(eventType, event => {
                setTelegramWebAppEventText(t => {
                    const line = `[${(new Date()).toLocaleTimeString()}|${eventType}] ${JSON.stringify(event)}`;
                    const lines = [];
                    let pos = 0;
                    while (pos < line.length) {
                        lines.push(line.slice(pos, pos + 80));
                        pos += 80;
                    }
                    return `${t}\n\n${lines.join('\n')}`;
                })
            })
        })
    }

    return (
        <>
            {
                isDev && <>
                    {
                        (showDebugElements) ? (
                            <>
                                <hr/>
                                {
                                    window?.Telegram?.WebApp && <>
                                        <ul>
                                            <li>Telegram Bot API Version: {window.Telegram.WebApp.version}</li>
                                            <li>Telegram App Platform: {window.Telegram.WebApp.platform}</li>
                                            {/* <li>Telegram App <code>initData</code> User: <pre>{JSON.stringify(window.Telegram.WebApp.initDataUnsafe.user, null, 2)}</pre></li> */}
                                        </ul>
                                    </>
                                }

                                <hr/>

                                {/* <hr/>

                                <h4>QR Scan Test (Generic):</h4>
                                <HorizontallyCenteringContainer>
                                    {
                                        debugQrScanResult ? <div>
                                            <p>Scan Result: <code>{debugQrScanResult}</code></p>
                                        </div> : <div>
                                            <QrReader
                                                delay={250}
                                                style={{ height: 320, width: 320 }}
                                                onError={e => console.error('QR Scan Error:', e)}
                                                onScan={r => {
                                                    if (!!r) {
                                                        console.info('QR Scan Done:', r);
                                                        setDebugQrScanResult(r?.text);
                                                    }
                                                }}
                                                constraints={{
                                                    audio: false,
                                                    video: {
                                                        facingMode: 'rear',
                                                    },
                                                    legacyMode: true
                                                }}
                                            />
                                        </div>
                                    }
                                </HorizontallyCenteringContainer> */}

                                <hr/>
                                <h4>window: prompt, confirm, alert</h4>
                                <HorizontallyCenteringContainer>
                                    <div>
                                        Window Dialog Result: <pre>{debugWindowDialogResult}</pre>
                                    </div>

                                    <br/>

                                    <div>
                                        <Button onClick={() => {
                                            setDebugWindowDialogResult(null);
                                            const r = window.prompt('Prompt message', 'Default value');
                                            setDebugWindowDialogResult(`Prompt result: ${r}`)
                                        }}>
                                            Try Prompt
                                        </Button>
                                        &nbsp;
                                        <Button onClick={() => {
                                            setDebugWindowDialogResult(null);
                                            const r = window.confirm('Confirm message');
                                            setDebugWindowDialogResult(`Confirm result: ${r}`)
                                        }}>
                                            Try Confirm
                                        </Button>
                                        &nbsp;
                                        <Button onClick={() => {
                                            setDebugWindowDialogResult(null);
                                            window.alert('Alert message');
                                            setDebugWindowDialogResult(`Alert shown`)
                                        }}>
                                            Try Alert
                                        </Button>
                                    </div>
                                </HorizontallyCenteringContainer>


                                {
                                    (window?.Telegram?.WebApp && window?.Telegram?.WebApp?.platform !== 'tdesktop' && window?.Telegram?.WebApp?.platform !== 'unknown' && telegramWebAppVersion >= 6.4) && <>
                                        <hr/>

                                        <h4>QR Scan Test (Alt.):</h4>
                                        <HorizontallyCenteringContainer>
                                            {
                                                debugTelegramQrScanResult ? <div style={{ fontSize: '0.7em', display: 'block', justifyContent: 'left' }}>
                                                    <div>Scan Result:</div>
                                                    {
                                                        debugTelegramQrScanResult.map((s, idx) => (
                                                            <div key={`qrRes-${idx}`}>
                                                                <code>{s}</code>
                                                            </div>
                                                        ))
                                                    }
                                                </div> : <div>
                                                    <Button onClick={() => {
                                                        telegramQRScan().then(r => {
                                                            function splitToLines(s, n = 40) {
                                                                const r = [];
                                                                let balance = s;
                                                                while (balance.length > n) {
                                                                    r.push(balance.substr(0, n));
                                                                    balance = balance.substr(n);
                                                                }
                                                                if (balance.length > 0) {
                                                                    r.push(balance)
                                                                }
                                                                return r;
                                                            }

                                                            if (!r.startsWith('https://lsc.abrholdings.ltd/r#')) {
                                                                setDebugTelegramQrScanResult(splitToLines(r))
                                                            } else {
                                                                const link = r.split('#')[0];
                                                                const encodedTableInfo = r.split('#')[1];
                                                                const tableInfoParts = hexDecode(encodedTableInfo).split('_');
                                                                if (tableInfoParts.length !== 4) {
                                                                    setDebugTelegramQrScanResult(splitToLines(r))
                                                                } else {
                                                                    setDebugTelegramQrScanResult([
                                                                        `DECODED-STANDEE | ${tableInfoParts[1]} | ${tableInfoParts[2]}`,
                                                                        `Link: ${link}`,
                                                                        `Hash: ${encodedTableInfo}`,
                                                                    ])
                                                                }
                                                            }
                                                        }).catch(e => {
                                                            setDebugTelegramQrScanResult([`Error: ${e}`])
                                                        })
                                                    }}>
                                                        Try Scan QR
                                                    </Button>
                                                </div>                            
                                            }
                                        </HorizontallyCenteringContainer>
                                    </>
                                }

                                {
                                    (window?.Telegram?.WebApp && telegramWebAppVersion >= 6.2) && <>
                                        <hr/>

                                        <h4>Alert/Confirm/Popup Test:</h4>
                                        <HorizontallyCenteringContainer>
                                            {
                                                debugPopupResult ? <div>
                                                    Popup Result: <pre>{debugPopupResult}</pre>
                                                </div> : <div>
                                                    <Button onClick={() => {
                                                        window.Telegram.WebApp.showAlert('alert message', () => {
                                                            setDebugPopupResult('Alert Callback Called')
                                                        })
                                                    }}>
                                                        Try Alert
                                                    </Button>
                                                    &nbsp;
                                                    <Button onClick={() => {
                                                        window.Telegram.WebApp.showConfirm('confirm?', m => {
                                                            console.log('Confirm Result:', m)
                                                            setDebugPopupResult(JSON.stringify(m, null, 2))
                                                        })
                                                    }}>
                                                        Try Confirm
                                                    </Button>
                                                    &nbsp;

                                                    <br/>
                                                    <Button onClick={() => {
                                                        window.Telegram.WebApp.showPopup({
                                                            title: 'Popup Title',
                                                            message: 'Popup message',
                                                            buttons: [
                                                                // up to 3 buttons
                                                                { id: 'ok', type: 'ok'},
                                                                { id: 'close', type: 'close'},
                                                                { id: 'cancel', type: 'cancel'},
                                                                // { id: 'default', type: 'default', text: 'Default' },
                                                                // { id: 'destructive', type: 'destructive', text: 'Delete' },
                                                            ]
                                                        }, m => {
                                                            console.log('Popup Result:', m)
                                                            setDebugPopupResult(JSON.stringify(m, null, 2))
                                                        })
                                                    }}>
                                                        Try Popup 1
                                                    </Button>
                                                    &nbsp;
                                                    <Button onClick={() => {
                                                        window.Telegram.WebApp.showPopup({
                                                            title: 'Popup Title',
                                                            message: 'Popup message',
                                                            buttons: [
                                                                // up to 3 buttons
                                                                { id: 'ok', type: 'ok'},
                                                                // { id: 'close', type: 'close'},
                                                                // { id: 'cancel', type: 'cancel'},
                                                                { id: 'default', type: 'default', text: 'Default' },
                                                                { id: 'destructive', type: 'destructive', text: 'Delete' },
                                                            ]
                                                        }, m => {
                                                            console.log('Popup Result:', m)
                                                            setDebugPopupResult(JSON.stringify(m, null, 2))
                                                        })
                                                    }}>
                                                        Try Popup 2
                                                    </Button>
                                                </div>
                                            }
                                        </HorizontallyCenteringContainer>
                                    </>
                                }

                                {
                                    (window?.Telegram?.WebApp && telegramWebAppVersion >= 6.2) && <>
                                        <hr/>

                                        <h4>Request Contact Test:</h4>
                                        <HorizontallyCenteringContainer>
                                            {
                                                debugRequestContactResult ? <div>
                                                    Request Contact Result: <pre>{debugRequestContactResult}</pre>
                                                </div> : <div>
                                                    <Button onClick={() => {
                                                        window.Telegram.WebApp.requestContact(r => {
                                                            setDebugRequestContactResult(JSON.stringify(r, null, 2))
                                                        })
                                                    }}>
                                                        Try Request Contact
                                                    </Button>
                                                </div>
                                            }
                                        </HorizontallyCenteringContainer>
                                    </>
                                }

                                {
                                    (window?.Telegram?.WebApp?.HapticFeedback && telegramWebAppVersion >= 6.1) && <>
                                        <hr/>

                                        <h4>Haptics Test:</h4>
                                        <HorizontallyCenteringContainer>
                                        <Button onClick={() => {
                                                    telegramHapticFeedback('success')
                                                }}>
                                                    Success
                                                </Button>
                                                &nbsp;
                                                <Button onClick={() => {
                                                    telegramHapticFeedback('warning')
                                                }}>
                                                    Warning
                                                </Button>
                                                &nbsp;
                                                <Button onClick={() => {
                                                    telegramHapticFeedback('error')
                                                }}>
                                                    Error
                                                </Button>
                                        </HorizontallyCenteringContainer>
                                    </>
                                }

                                {
                                    debugLocationInfo && <>
                                        <hr/>
                                        <HorizontallyCenteringContainer>
                                            <div>
                                                Location Info:
                                                <pre>{JSON.stringify(debugLocationInfo, null, 2)}</pre>
                                            </div>
                                        </HorizontallyCenteringContainer>
                                    </>
                                }

                                {
                                    debugMediaInfo && <>
                                        <hr/>
                                        <HorizontallyCenteringContainer>
                                            <div>
                                                Media Devices (count={debugMediaInfo.length}):
                                                <ul>
                                                    {
                                                        debugMediaInfo.map((mi, idx) => (
                                                            <li key={`${idx}-${mi.deviceId}`}>
                                                                {idx}: {mi.label}
                                                                <ul>
                                                                    <li>kind=<code>{mi.kind}</code></li>
                                                                    <li>deviceId=<code>{mi?.deviceId?.substr(0, 20)}...</code></li>
                                                                    <li>groupId=<code>{mi?.groupId?.substr(0, 20)}...</code></li>
                                                                </ul>
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                            </div>
                                        </HorizontallyCenteringContainer>
                                    </>
                                }

                                {
                                    <>
                                        <hr/>
                                        <h4>Telegram Events</h4>
                                        <pre>{telegramWebAppEventText}</pre>
                                    </>
                                }

                                <VerticalSeparator height='10px'/>
                            </>
                        ) : (
                            DEBUG_ELEMENTS_ALLOWED_CARD_NUMBERS.includes(memberData?.__member_record__?.membership_code) ? (
                                <>
                                    <hr/>
                                    <HorizontallyCenteringContainer>
                                        <Button onClick={() => setShowDebugElements(true)}>
                                            Show Debug Elements
                                        </Button>
                                    </HorizontallyCenteringContainer>
                                </>
                            ): <></>
                        )
                    }
                </>
            }
        </>
    );
}
